export default __webpack_public_path__ + "a1e88f4d36612ff1dbbbdf7ce4c9627a.svg";